import { NumberFileTag } from 'exifreader';
import { InspectionSchema } from '../_offline/models/inspection.schema';

export enum InspectionPermission {
  Non, // 0 権限なし
  Read, // 1 参照
  Write // 2 編集
}
export class Inspection {
  id: string;
  title: string;
  subjectModelId: string;
  subjectId: string;
  subjectSerialNo: string;
  inspectionDate: string;
  status: string;
  inspectors: Inspector[];
  isValid: boolean;
  isDeleted: boolean;
  permission: number;
  schemaVersion: string;
  createdBy: string;
  createDate: string;
  lastUpdatedBy: string;
  lastUpdateDate: string;
  inspectionLocations: InspectionLocation[];
  sharedLockBy: string;
  locationVersion: number;
  attributesVersion: number;
  imageCount: number;
  connectorTenantId: string | null;
  reportCount: number;
}

export class InspectionImagesCount {
  inspectionId: string;
  count: number;
}

export class Inspector {
  id: string;
  isActive: boolean;
  isSubscription: boolean;
  // name: string;
}

export class InspectionLocation {
  identifier: string;
  comment: string;

  constructor(identifier: string, comment: string) {
    this.identifier = identifier;
    this.comment = comment;
  }
}

export class InspectionUpdateLocation {
  inspectionId: string;
  inspectionLocations: InspectionLocation[];

  constructor(id: string, inspectionLocations: InspectionLocation[],) {
    this.inspectionId = id;
    this.inspectionLocations = inspectionLocations;
  }
}

export class InspectionList {
  total: number;
  page: number;
  items: InspectionListItem[];
}

export class InspectionListItem {

  id: string;
  title: string;
  subjectModelId: string;
  subjectModelName: string;
  subjectSerialNo: string;
  inspectionDate: string;
  status: string;
  permission: number;
  inspectors: Inspector[];
  sharedLockBy: string;
  isOfflineData = false;
  isDeleted: boolean;
  imageCount: number;
  connectorTenantId: string;
  reportCount: number;

  setInspectionSchema(schema: InspectionSchema) {
    this.id = schema.id;
    this.title = schema.title;
    this.subjectModelId = schema.subject.subjectModelId;
    this.subjectModelName = schema.subject.subjectModel.name;
    this.subjectSerialNo = schema.subject.serialNo;
    this.inspectionDate = schema.inspectionDate;
    this.status = schema.status;
    this.inspectors = JSON.parse(schema.inspectors) as Inspector[];
    this.sharedLockBy = schema.sharedLockBy;
    this.isOfflineData = schema.isOfflineData;
    this.imageCount = schema.imageCount;
    this.connectorTenantId = schema.connectorTenantId;
    this.reportCount = schema.reportCount;
  }
}

export class ImageCount {
  total: number;
  image: number;
  movie: number;
  dataPlate: number;
}

export class InspectionDetailNew {
  title: string;
  subjectId: string;
  inspectionDate: string;
  inspectors: Inspector[];
  status: string;
  schemaVersion: string;
  imageCount: number;
  connectorTenantId: string | null;
  reportCount: number;

}

export class InspectionDetailUpdate extends InspectionDetailNew {
  id: string;
  isValid: boolean;
  locationVersion: number;
}

export class InspectionForOffline {
  id: string;
  isDeleted: boolean;
  isValid: boolean;
  schemaVersion: string;
  createdBy: string;
  createDate: string;
  lastUpdatedBy: string;
  lastUpdateDate: string;
  title: string;
  subjectId: string;
  inspectionDate: string;
  status: string;
  inspectors: Inspector[];
  inspectionLocations: InspectionLocation[];
  tenantId: string;
  sharedLockBy: string;
  locationVersion: number;
  imageCount: number;
  connectorTenantId: string | null;
  reportCount: number;

  constructor(inspectionSchema: InspectionSchema) {
    this.id = inspectionSchema.id;
    this.isDeleted = inspectionSchema.isDeletedFlag;
    this.isValid = inspectionSchema.isValid;
    this.schemaVersion = inspectionSchema.schemaVersion;
    this.createdBy = inspectionSchema.createdBy;
    this.createDate = inspectionSchema.createDate;
    this.lastUpdatedBy = inspectionSchema.lastUpdatedBy;
    this.lastUpdateDate = inspectionSchema.lastUpdateDate;
    this.title = inspectionSchema.title;
    this.subjectId = inspectionSchema.subjectId;
    this.inspectionDate = inspectionSchema.inspectionDate;
    this.status = inspectionSchema.status;
    this.inspectionLocations = JSON.parse(inspectionSchema.inspectionLocations) as InspectionLocation[];

    this.inspectors = JSON.parse(inspectionSchema.inspectors) as Inspector[];

    this.tenantId = inspectionSchema.tenantId;

    this.sharedLockBy = inspectionSchema.sharedLockBy;
    this.locationVersion = inspectionSchema.locationVersion;
    this.imageCount = inspectionSchema.imageCount;
    this.connectorTenantId = inspectionSchema.connectorTenantId;
    this.reportCount = inspectionSchema.reportCount;

  }
}

export class InspectorId {
  id: string;

  constructor(id: string) {
    this.id = id;
  }
}

export class InspectionForSharedLock {
  id: string;

  constructor(id: string) {
    this.id = id;
  }
}
